const inject = (str: string, obj: Record<string, any>) =>
  str.replace(/\${(.*?)}/g, (x, g) => obj?.[g])

export default inject
